import { createSlice } from "@reduxjs/toolkit";

export const MessagesSlice = createSlice({
  name: "Messages",
  initialState: {
    messages: [],
  },
  reducers: {
    addSuccessMessage: (state, { payload }) => {
      let date = new Date().getMilliseconds().toString();
      if (state.messages.find((item) => item.id === date) === undefined) {
        state.messages.push({
          text: payload,
          id: date,
          type: "success",
        });
      }
    },
    addErrorMessage: (
      state,
      {
        payload: {
          status,
          data: { message },
        },
      }
    ) => {
      let date = new Date().getMilliseconds().toString();
      if (state.messages.find((item) => item.id === date) === undefined) {
        if (status !== 401)
          state.messages.push({
            text: message,
            id: date,
            type: "error",
          });
      }
    },
    addWarnMessage: (state, { payload }) => {
      let date = new Date().getMilliseconds().toString();
      if (state.messages.find((item) => item.id === date) === undefined) {
        state.messages.push({
          text: payload,
          id: date,
          type: "warn",
        });
      }
    },
    addNewMessage: (state, { payload }) => {
      if (state.messages.find((item) => item.id === payload.id) === undefined) {
        state.messages.push(payload);
      }
    },
    addServerMessage: (state, { payload }) => {
      switch (payload.status) {
        case 400:
          state.messages.push({ message: payload.message, variant: "error", id: payload.status });
          break;
        case 500:
          state.messages.push({
            message: "خطایی در سرور رخ داده لطفا بعدا تلاش کنید ",
            variant: "error",
            id: payload.status,
          });
          break;
        default:
          state.messages.push({
            message: "خطایی رخ داده لطفا مجدد تلاش کنید",
            variant: "error",
            id: 1400,
          });
          break;
      }
    },
    removeMessage: (state, { payload }) => {
      state.messages = state.messages.filter((item) => item.id !== payload);
    },
  },
});

export const {
  addNewMessage,
  addServerMessage,
  removeMessage,
  addSuccessMessage,
  addWarnMessage,
  addErrorMessage,
} = MessagesSlice.actions;

export const MessagesReducer = MessagesSlice.reducer;
